<template>
  <MainLayout selectMenu="1-1" siderMenu="12-1" sideBar="machine">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
      <Tabs v-model="mode" type="card" class="custom-tabs">
        <TabPane :label="getTranslation('k009')" name="0" class="custom-tabpane" >
          <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('b005') }}</div>
            <Row class="limit-line" type="flex">
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b006') }}</Col>
                <Col flex="1"><Select :filterable="true" size="small" :transfer="true" class="input-field" :placeholder="getTranslation('m034')"
                  v-model="selectLibraryId" @on-change="libraryChange()" :not-found-text="getTranslation('b038')"                  
                  >
                  <Option v-for="item in allLibrary" :value="item.id" :key="item.id">{{ item.ProgramId }}</Option>
                </Select>
                </Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b008') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld1"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b010') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld2"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b012') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld3"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b014') }}</Col>
                <Col flex="1"><Select :transfer="true" size="small" class="input-field" v-model="selectLibrary.OptPowerControl"
                  @on-change="changePowerControl">
                  <Option v-for="(item, index) in powControlList" :value="index" :key="index">{{ item }}</Option>
                </Select>
                </Col>
              </Row>
              </Col>
            </Row>
            <Row class="limit-line" type="flex">
              <Row type="flex"></Row>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b007') }}</Col>
                <Col flex="1"><Input type="text" size="small" class="input-field" v-model="selectLibrary.WeldProgram"
                  maxlength="50" />
                </Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b009') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld1"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b011') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld2"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b013') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld3"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              </Col>
            </Row>
          </Card>
          <!-- 分隔区域 -->
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="other-line">
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1">
              </Col>
              <Col flex="2">{{ getTranslation('b018') }}</Col>
              <Col flex="2">{{ getTranslation('b019') }}</Col>
              <Col flex="2">{{ getTranslation('b020') }}</Col>
              <Col flex="2">{{ getTranslation('b021') }}</Col>
              <Col flex="2">{{ getTranslation('b022') }}</Col>
              <Col flex="2">{{ getTranslation('b023') }}</Col>
              <Col flex="2">{{ getTranslation('b024') }}</Col>
              <Col flex="2">{{ getTranslation('b025') }}</Col>
              <Col flex="2">{{ getTranslation('b026') }}</Col>
              <Col flex="2">{{ getTranslation('b027') }}</Col>
              <Col flex="2">{{ getTranslation('b028') }}</Col>
              <Col flex="2">{{ getTranslation('b029') }}</Col>
              <Col flex="2">{{ getTranslation('b030') }}</Col>
              <Col flex="2">{{ getTranslation('b031') }}</Col>
              <Col flex="2">{{ getTranslation('b032') }}</Col>
              <Col flex="1">
              </Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-mode.png')" /></Col>
              <Col flex="10">
              </Col>
              <Col flex="2" class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary.OptWeld1">
                <Option v-for="(item, index) in weldList" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="2">
              </Col>
              <Col flex="2" class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary.OptWeld2">
                <Option v-for="(item, index) in weldList" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="2">
              </Col>
              <Col flex="2" class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary.OptWeld3">
                <Option v-for="(item, index) in weldList" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="11">
              </Col>
            </Row>
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrPreWeld" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld1" /></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld2" /></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld3" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrPostWeld" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="1">KA</Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimPrePress" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimMorePress" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimPreWeld" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimCold0" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimAscentWeld" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimWeld1" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimCold1" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimWeld2" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimCold2" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimWeld3" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimDescendWeld" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimCold3" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimPostWeld" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimKeep" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.TimRelease" /></Col>
              <Col flex="1"><template v-if="kind == 62">cyc</template><template v-else>ms</template></Col>
            </Row>
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-pss.png')" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.PssPrePress" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.PssMorePress" />
              </Col>
              <Col flex="10">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.PssWeld2" /></Col>
              <Col flex="12">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.PssRelease" /></Col>
              <Col flex="1">KN</Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="13">
              </Col>
              <Col flex="2">{{ getTranslation('b037') }}</Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary.NumWeldPulse2" />
              </Col>
              <Col flex="15">
              </Col>
            </Row>
          </div>
          <!-- 分隔区域 -->
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="other-line bordered-group">
            <Row type="flex" class="row-line">
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k011') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.OptGunNum" /></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k012') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValExpulsionCnt" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k013') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input"
                  v-model="selectLibrary.ValExpulsionResDec" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k014') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input"
                  v-model="selectLibrary.ValExpulsionTime" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k015') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValWeldRestRef" />
                </Col>
              </Row>
              </Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k016') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValResMin" /></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k017') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValResMax" /></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b215') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValDutyRef" />%
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b216') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValDutySum" disabled />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b217') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary.ValDutyCnt" />
                </Col>
              </Row>
              </Col>
            </Row>
          </div>
          <div class="menu-actions">
            <Button type="primary" size="small" icon="md-download" @click.native="downloadProgram()">{{ getTranslation('k023')
              }}</Button>&nbsp;
            <Button type="warning" size="small" icon="md-refresh" @click.native="syncProgram()">{{ getTranslation('k024')
              }}</Button>&nbsp;
            <Button type="info" size="small" icon="md-cloud-download" @click.native="exportProgram()">{{ getTranslation('k025')
              }}</Button>
            &nbsp;
            <Button type="success" size="small" icon="md-cloud-upload" @click.native="importProgram()">{{ getTranslation('k026')
              }}</Button>
          </div>
        </TabPane>
        <TabPane :label="getTranslation('k010')" name="1" class="custom-tabpane" >
          <div v-if="mode==1">
          <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('b005') }}</div>
            <Row class="limit-line" type="flex">
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b006') }}</Col>
                <Col flex="1"><Select :filterable="true" size="small" :transfer="true" class="input-field" :placeholder="getTranslation('m034')"
                  v-model="selectLibraryId2" @on-change="libraryChange2()" :not-found-text="getTranslation('b038')">
                  <Option v-for="item in allLibrary" :value="item.id" :key="item.id">{{ item.ProgramId }}</Option>
                </Select>
                </Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b008') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld1Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b010') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld2Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b012') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMinWeld3Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b014') }}</Col>
                <Col flex="1"><Select :transfer="true" size="small" class="input-field" v-model="selectLibrary2.OptPowerControl"
                  @on-change="changePowerControl2">
                  <Option v-for="(item, index) in powControlList" :value="index" :key="index">{{ item }}</Option>
                </Select>
                </Col>
              </Row>
              </Col>
            </Row>
            <Row class="limit-line" type="flex">
              <Row type="flex"></Row>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b007') }}</Col>
                <Col flex="1"><Input type="text" size="small" class="input-field" v-model="selectLibrary2.WeldProgram"
                  maxlength="50" />
                </Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b009') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld1Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b011') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld2Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              <Row type="flex">
                <Col flex="1" class="left-program">{{ getTranslation('b013') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input-field" v-model="formattedCrrMaxWeld3Two"></Input></Col>
              </Row>
              </Col>
              <Col flex="1" class="desc-field">
              </Col>
            </Row>
          </Card>
          <!-- 分隔区域 -->
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="other-line">
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1">
              </Col>
              <Col flex="2">{{ getTranslation('b018') }}</Col>
              <Col flex="2">{{ getTranslation('b019') }}</Col>
              <Col flex="2">{{ getTranslation('b020') }}</Col>
              <Col flex="2">{{ getTranslation('b021') }}</Col>
              <Col flex="2">{{ getTranslation('b022') }}</Col>
              <Col flex="2">{{ getTranslation('b023') }}</Col>
              <Col flex="2">{{ getTranslation('b024') }}</Col>
              <Col flex="2">{{ getTranslation('b025') }}</Col>
              <Col flex="2">{{ getTranslation('b026') }}</Col>
              <Col flex="2">{{ getTranslation('b027') }}</Col>
              <Col flex="2">{{ getTranslation('b028') }}</Col>
              <Col flex="2">{{ getTranslation('b029') }}</Col>
              <Col flex="2">{{ getTranslation('b030') }}</Col>
              <Col flex="2">{{ getTranslation('b031') }}</Col>
              <Col flex="2">{{ getTranslation('b032') }}</Col>
              <Col flex="1">
              </Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-mode.png')" /></Col>
              <Col flex="10">
              </Col>
              <Col flex="2"  class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary2.OptWeld1">
                <Option v-for="(item, index) in weldList2" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"  class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary2.OptWeld2">
                <Option v-for="(item, index) in weldList2" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"  class="no-wrap" ><Select :transfer="true" size="small" class="input" v-model="selectLibrary2.OptWeld3">
                <Option v-for="(item, index) in weldList2" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select></Col>
              <Col flex="11">
              </Col>
            </Row>
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrPreWeldTwo" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld1Two" /></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld2Two" /></Col>
              <Col flex="2">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrWeld3Two" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="formattedCrrPostWeldTwo" /></Col>
              <Col flex="4">
              </Col>
              <Col flex="1">KA</Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimPrePress" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimMorePress" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimPreWeld" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimCold0" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimAscentWeld" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimWeld1" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimCold1" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimWeld2" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimCold2" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimWeld3" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimDescendWeld" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimCold3" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimPostWeld" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimKeep" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.TimRelease" /></Col>
              <Col flex="1">ms</Col>
            </Row>
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-pss.png')" /></Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.PssPrePress" />
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.PssMorePress" />
              </Col>
              <Col flex="10">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.PssWeld2" /></Col>
              <Col flex="12">
              </Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.PssRelease" /></Col>
              <Col flex="1">KN</Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="13">
              </Col>
              <Col flex="2">{{ getTranslation('b037') }}</Col>
              <Col flex="2"><Input type="number" size="small" class="input" v-model="selectLibrary2.NumWeldPulse2" />
              </Col>
              <Col flex="15">
              </Col>
            </Row>
          </div>
          <!-- 分隔区域 -->
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="other-line bordered-group">
            <Row type="flex" class="row-line">
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k011') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.OptGunNum" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k012') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input"
                  v-model="selectLibrary2.ValExpulsionCnt" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k013') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input"
                  v-model="selectLibrary2.ValExpulsionResDec" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k014') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input"
                  v-model="selectLibrary2.ValExpulsionTime" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k015') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValWeldRestRef" />
                </Col>
              </Row>
              </Col>
            </Row>
            <Row type="flex" class="row-line">
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k016') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValResMin" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('k017') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValResMax" />
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b215') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValDutyRef" />%
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b216') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValDutySum" disabled/>
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row type="flex">
                <Col flex="2" class="left-program">{{ getTranslation('b217') }}</Col>
                <Col flex="1"><Input type="number" size="small" class="input" v-model="selectLibrary2.ValDutyCnt" />
                </Col>
              </Row>
              </Col>
            </Row>
          </div>
          <div class="menu-actions">
            <Button type="primary" size="small"  icon="md-checkmark" @click.native="saveProgram()">{{ getTranslation('c006')
              }}</Button>&nbsp;
            <Button type="warning" size="small"  icon="md-refresh" @click.native="syncProgram()">{{ getTranslation('k264')
              }}</Button>&nbsp;
            <Button type="info" size="small"  icon="md-cloud-download" @click.native="exportProgram()">{{ getTranslation('k025')
              }}</Button>
            &nbsp;
            <Button type="success" size="small"  icon="md-cloud-upload" @click.native="importProgram()">{{ getTranslation('k026')
              }}</Button>
          </div>
          </div>
        </TabPane>
      </Tabs>
      <SycProgram v-model="syncModalVisible" :propVisible="syncModalVisible" :mode="mode" :mac="mac"
        :id="selectProgramId" :libSize="libSize"></SycProgram>
      <ExportProgram v-model="exportModalVisible" :propVisible="exportModalVisible" :mode="mode" :mac="mac"
        :libSize="libSize"></ExportProgram>
  

      <!-- 导入确认对话框 -->
      <Modal v-model="importConfirmVisible" title="" @on-ok="handleImportConfirm" @on-cancel="handleImportCancel"
        :ok-text="getTranslation('k026')" :cancelText="getTranslation('b182')" cancel-text="" width="400">
        <p>{{ getTranslation('b171') }}</p>
      </Modal>

      <!-- 隐藏的文件上传组件 -->
      <Upload ref="fileUpload"  name="file" action=""
      :before-upload="handleBeforeUpload"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :show-upload-list="false"
      style="display: none"></Upload>
      <PageProgress v-model="pageProgressModalVisible" :progressKey="progressKey" :pageProgressModalVisible="pageProgressModalVisible" :oneProgress="oneProgress" ></PageProgress>

    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import { API_URL } from '@/constants/const';
import MainLayout from '@/components/MainLayout.vue'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { Tabs, TabPane, Card, Row, Col, Button, Select, Option, Input, Upload, Modal } from "view-design"
import { formatToTwoDecimals } from '@/util/numberFormat';
import { setSidbarBreadCrumb, postJsError, setDashboardPage } from '@/util/util.js';
import SycProgram from "./components/SyncProgram.vue"
import ExportProgram from "./components/ExportProgram.vue"
import NoAuth from '@/components/NoAuth.vue'
import PageProgress from '@/components/PageProgress.vue';
import WebSocket from '@/components/WebSocket.vue';
export default {
  name: 'ProgramIndex', // 组件名称
  components: {
    MainLayout, Tabs, TabPane, Card, Row, Col, Button, Select, Option, Input, SycProgram, ExportProgram, Upload,
     Modal, NoAuth, PageProgress, WebSocket
  },
  watch: {
    // 监听selectLibrary变化，确保界面更新
    // 监听selectLibrary变化，强制计算属性重新计算
    selectLibrary: {
      handler(newVal) {
        if (newVal) {
          // 当数据变化时，使用$nextTick确保计算属性重新计算
          this.$nextTick(() => {
            // 这里不需要做任何操作，Vue会自动处理计算属性的依赖
          });
        }
      },
      deep: true,
      immediate: true
    },
    selectLibrary2: {
      handler(newVal) {
        if (newVal) {
          // 当数据变化时，使用$nextTick确保计算属性重新计算
          this.$nextTick(() => {
            // 这里不需要做任何操作，Vue会自动处理计算属性的依赖
          });
        }
      },
      deep: true,
      immediate: true
    },
    mode: {
      handler(newVal) {
        if (newVal == 1 ) {          
          this.libraryChange2();
        }else if (newVal == 0 ) {
          this.libraryChange();
        }
      },


    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    powControlList() {
      return [
        this.getTranslation("b016"),
        this.getTranslation("b017"),
        this.getTranslation("b015"),
      ]
    },
    weldList() {
      let rs = [];
      if (this.selectLibrary && this.selectLibrary.OptPowerControl !== undefined) {
        let val = parseInt(this.selectLibrary.OptPowerControl)

        switch (val) {
          case 0:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              }
            ]
            break;
          case 1:
            rs = [
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          case 2:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              },
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          default:
            break;
        }
      } else {
        rs = [
          {
            "key": 0,
            "value": this.getTranslation("b016"),
          },
          {
            "key": 1,
            "value": this.getTranslation("b017"),
          }
        ]
      }
      return rs;
    },
    weldList2() {
      let rs = [];
      if (this.selectLibrary2 && this.selectLibrary2.OptPowerControl !== undefined) {
        let val = parseInt(this.selectLibrary2.OptPowerControl)

        switch (val) {
          case 0:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              }
            ]
            break;
          case 1:
            rs = [
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          case 2:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              },
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          default:
            break;
        }
      } else {
        rs = [
          {
            "key": 0,
            "value": this.getTranslation("b016"),
          },
          {
            "key": 1,
            "value": this.getTranslation("b017"),
          }
        ]
      }
      return rs;
    },
    formattedCrrMinWeld1: {
      get() {
        if (this.lockGet[0]) {
          this.lockGet[0] = false;
          return this.selectLibrary.CrrMinWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMinWeld1);
        }
      },
      set(value) {
        this.lockGet[0] = true;
        this.$set(this.selectLibrary, 'CrrMinWeld1', value);
      }
    },
    formattedCrrMinWeld2: {
      get() {
        if (this.lockGet[1]) {
          this.lockGet[1] = false;
          return this.selectLibrary.CrrMinWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMinWeld2);
        }
      },
      set(value) {
        this.lockGet[1] = true;
        this.$set(this.selectLibrary, 'CrrMinWeld2', value);
      }
    },
    formattedCrrMinWeld3: {
      get() {
        if (this.lockGet[2]) {
          this.lockGet[2] = false;
          return this.selectLibrary.CrrMinWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMinWeld3);
        }
      },
      set(value) {
        this.lockGet[2] = true;
        this.$set(this.selectLibrary, 'CrrMinWeld3', value);
      }
    },
    formattedCrrMaxWeld1: {
      get() {
        if (this.lockGet[3]) {
          this.lockGet[3] = false;
          return this.selectLibrary.CrrMaxWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMaxWeld1);
        }
      },
      set(value) {
        this.lockGet[3] = true;
        this.$set(this.selectLibrary, 'CrrMaxWeld1', value);
      }
    },
    formattedCrrMaxWeld2: {
      get() {
        if (this.lockGet[4]) {
          this.lockGet[4] = false;
          return this.selectLibrary.CrrMaxWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMaxWeld2);
        }
      },
      set(value) {
        this.lockGet[4] = true;
        this.$set(this.selectLibrary, 'CrrMaxWeld2', value);
      }
    },
    formattedCrrMaxWeld3: {
      get() {
        if (this.lockGet[5]) {
          this.lockGet[5] = false;
          return this.selectLibrary.CrrMaxWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrMaxWeld3);
        }
      },
      set(value) {
        this.lockGet[5] = true;
        this.$set(this.selectLibrary, 'CrrMaxWeld3', value);
      }
    },
    formattedCrrPreWeld: {
      get() {
        if (this.lockGet[6]) {
          this.lockGet[6] = false;
          return this.selectLibrary.CrrPreWeld;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrPreWeld);
        }
      },
      set(value) {
        this.lockGet[6] = true;
        this.$set(this.selectLibrary, 'CrrPreWeld', value);
      }
    },
    formattedCrrWeld1: {
      get() {
        if (this.lockGet[7]) {
          this.lockGet[7] = false;
          return this.selectLibrary.CrrWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrWeld1);
        }
      },
      set(value) {
        this.lockGet[7] = true;
        this.$set(this.selectLibrary, 'CrrWeld1', value);
      }
    },
    formattedCrrWeld2: {
      get() {
        if (this.lockGet[8]) {
          this.lockGet[8] = false;
          return this.selectLibrary.CrrWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrWeld2);
        }
      },
      set(value) {
        this.lockGet[8] = true;
        this.$set(this.selectLibrary, 'CrrWeld2', value);
      }
    },
    formattedCrrWeld3: {
      get() {
        if (this.lockGet[9]) {
          this.lockGet[9] = false;
          return this.selectLibrary.CrrWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrWeld3);
        }
      },
      set(value) {
        this.lockGet[9] = true;
        this.$set(this.selectLibrary, 'CrrWeld3', value);
      }
    },
    formattedCrrPostWeld: {
      get() {
        if (this.lockGet[10]) {
          this.lockGet[10] = false;
          return this.selectLibrary.CrrPostWeld;
        } else {
          return formatToTwoDecimals(this.selectLibrary.CrrPostWeld);
        }
      },
      set(value) {
        this.lockGet[10] = true;
        this.$set(this.selectLibrary, 'CrrPostWeld', value);
      }
    },
    formattedCrrMinWeld1Two: {
      get() {
        if (this.lockGet2[0]) {
          this.lockGet2[0] = false;
          return this.selectLibrary2.CrrMinWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMinWeld1);
        }
      },
      set(value) {
        this.lockGet2[0] = true;
        this.$set(this.selectLibrary2, 'CrrMinWeld1', value);
      }
    },
    formattedCrrMinWeld2Two: {
      get() {
        if (this.lockGet2[1]) {
          this.lockGet2[1] = false;
          return this.selectLibrary2.CrrMinWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMinWeld2);
        }
      },
      set(value) {
        this.lockGet2[1] = true;
        this.$set(this.selectLibrary2, 'CrrMinWeld2', value);
      }
    },
    formattedCrrMinWeld3Two: {
      get() {
        if (this.lockGet2[2]) {
          this.lockGet2[2] = false;
          return this.selectLibrary2.CrrMinWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMinWeld3);
        }
      },
      set(value) {
        this.lockGet2[2] = true;
        this.$set(this.selectLibrary2, 'CrrMinWeld3', value);
      }
    },
    formattedCrrMaxWeld1Two: {
      get() {
        if (this.lockGet2[3]) {
          this.lockGet2[3] = false;
          return this.selectLibrary2.CrrMaxWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMaxWeld1);
        }
      },
      set(value) {
        this.lockGet2[3] = true;
        this.$set(this.selectLibrary2, 'CrrMaxWeld1', value);
      }
    },
    formattedCrrMaxWeld2Two: {
      get() {
        if (this.lockGet2[4]) {
          this.lockGet2[4] = false;
          return this.selectLibrary2.CrrMaxWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMaxWeld2);
        }
      },
      set(value) {
        this.lockGet2[4] = true;
        this.$set(this.selectLibrary2, 'CrrMaxWeld2', value);
      }
    },
    formattedCrrMaxWeld3Two: {
      get() {
        if (this.lockGet2[5]) {
          this.lockGet2[5] = false;
          return this.selectLibrary2.CrrMaxWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrMaxWeld3);
        }
      },
      set(value) {
        this.lockGet2[5] = true;
        this.$set(this.selectLibrary2, 'CrrMaxWeld3', value);
      }
    },
    formattedCrrPreWeldTwo: {
      get() {
        if (this.lockGet2[6]) {
          this.lockGet2[6] = false;
          return this.selectLibrary2.CrrPreWeld;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrPreWeld);
        }
      },
      set(value) {
        this.lockGet2[6] = true;
        this.$set(this.selectLibrary2, 'CrrPreWeld', value);
      }
    },
    formattedCrrWeld1Two: {
      get() {
        if (this.lockGet2[7]) {
          this.lockGet2[7] = false;
          return this.selectLibrary2.CrrWeld1;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrWeld1);
        }
      },
      set(value) {
        this.lockGet2[7] = true;
        this.$set(this.selectLibrary2, 'CrrWeld1', value);
      }
    },
    formattedCrrWeld2Two: {
      get() {
        if (this.lockGet2[8]) {
          this.lockGet2[8] = false;
          return this.selectLibrary2.CrrWeld2;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrWeld2);
        }
      },
      set(value) {
        this.lockGet2[8] = true;
        this.$set(this.selectLibrary2, 'CrrWeld2', value);
      }
    },
    formattedCrrWeld3Two: {
      get() {
        if (this.lockGet2[9]) {
          this.lockGet2[9] = false;
          return this.selectLibrary2.CrrWeld3;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrWeld3);
        }
      },
      set(value) {
        this.lockGet2[9] = true;
        this.$set(this.selectLibrary2, 'CrrWeld3', value);
      }
    },
    formattedCrrPostWeldTwo: {
      get() {
        if (this.lockGet2[10]) {
          this.lockGet2[10] = false;
          return this.selectLibrary2.CrrPostWeld;
        } else {
          return formatToTwoDecimals(this.selectLibrary2.CrrPostWeld);
        }
      },
      set(value) {
        this.lockGet2[10] = true;
        this.$set(this.selectLibrary2, 'CrrPostWeld', value);
      }
    },
    selectProgramId() {
      let rs = -1;
      if (this.allLibrary && this.allLibrary.length > 0) {
        this.allLibrary.forEach(item => {
          if (item.id == this.selectLibraryId && this.mode == 0) {
            rs = item.program_id;
          }
          if (item.id == this.selectLibraryId2 && this.mode == 1) {
            rs = item.program_id;
          }
        })

      }
      return rs;
    },
    errTitle() {
      return this.getTranslation("m062")
    },
    importUrl() {
      return API_URL["programImport"] + '?mac=' + this.mac + '&mode=' + this.mode;
    },
    uploadParam() {
      let param = {
        mac: this.mac,
        mode: this.mode,
      }
      return param
    },
     webSocketUrl() {
            return API_URL['webSocket']+ "?mac=" + this.$route.query.mac;;
        },
  },
  data() {
    return {
      selectLibraryId: -1,
      programId: -1,
      selectLibraryId2: -1,
      programId2: -1,
      selectLibrary: {},
      selectLibrary2: {},
      allLibrary: [],
      lockGet: [],
      lockGet2: [],
      deviceLibrarySize: 0,
      mode: "0",
      mac: 0,
      firstEnter: true,
      kind: 803,//机器类型
      originLibrary: {
        ProgramId: 0,
        WeldProgram: '',
        CrrMinWeld1: 0.00,
        CrrMaxWeld1: 0.00,
        CrrMinWeld2: 0.00,
        CrrMaxWeld2: 0.00,
        CrrMinWeld3: 0.00,
        CrrMaxWeld3: 0.00,
        TimPrePress: 0,
        PssPrePress: 0.00,
        TimMorePress: 0,
        PssMorePress: 0.00,
        OptPreWeld: 0,
        CrrPreWeld: 0.00,
        TimPreWeld: 0,
        PssPreWeld: 0.00,
        TimCold0: 0,
        PssCold0: 0,
        TimAscentWeld: 0,
        PssAscentWeld: 0.00,
        OptWeld1: 0,
        CrrWeld1: 0.00,
        TimWeld1: 0,
        PssWeld1: 0,
        TimCold1: 0,
        PssCold1: 0.00,
        OptWeld2: 0,
        CrrWeld2: 0.00,
        TimWeld2: 0,
        PssWeld2: 0.00,
        TimCold2: 0,
        PssCold2: 0,
        NumWeldPulse2: 0,
        OptWeld3: 0,
        CrrWeld3: 0.00,
        TimWeld3: 0,
        PssWeld3: 0,
        TimDescendWeld: 0,
        PssDescendWeld: 0.00,
        TimCold3: 0,
        PssCold3: 0,
        OptPostWeld: 0,
        CrrPostWeld: 0.00,
        TimPostWeld: 0,
        PssPostWeld: 0,
        TimKeep: 0,
        PssKeep: 0,
        TimRelease: 0,
        PssRelease: 0.00,
        OptPowerControl: 0,
        IsRirCurve: 0,
        OptGunNum: 0,
        ValExpulsionCnt: 0,
        ValExpulsionResDec: 0,
        ValExpulsionTime: 0,
        valWeldRestRef: 0,
        valResMin: 0,
        valResMax: 0
      },
      syncModalVisible: false,
      pageProgressModalVisible: false,
      exportModalVisible: false,
      importConfirmVisible: false,
      libSize: 0,
      hasAuth: true,
      tmpSelectLibraryId:-1,
      oneProgress:null,      
      progressKey:0,
    }
  },
  mounted() {

  },
  created() {
    setDashboardPage('program');
    this.init();
  },
  methods: {    
    init() {      
      let url = API_URL["programInit"];
      this.mac = parseInt(this.$route.query.mac)
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.deviceLibrarySize = res.data.data.size;
            this.kind = res.data.data.kind;
            this.$store.commit('setBreadcrumbItems', [
              { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
            ]);
            this.libSize = parseInt(res.data.data.size);
            this.allLibrary = this.createLibrary(res.data.data.size);
            // 如果有数据，总是选择第一个项目；如果没有数据，设置为-1
            if (this.allLibrary && this.allLibrary.length > 0) {
              this.selectLibraryId = this.allLibrary[0].id;
              this.selectLibraryId2 = this.allLibrary[0].id;
            } else {
              this.selectLibraryId = -1;
              this.selectLibraryId2 = -1;
            }
            this.libraryChange();

          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    createLibrary(size) {
      let rs = []
      for (var i = 0; i < size; i++) {
        rs.push({ "id": i, "ProgramId": i })
      }
      return rs;
    },
    libraryChange() {
      if (this.allLibrary && this.allLibrary.length > 0) {
        if (this.selectLibraryId > -1) {
          let url = API_URL["programInfo"];
          let params = {
            mac: this.mac,
            mode: this.mode,
            id: this.selectLibraryId
          };

          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.selectLibrary = { ...res.data.data };
                //this.$Message.success(res.data.msg);
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        } else {
          // 如果没有选中任何项，清空selectLibrary数据
          this.selectLibrary = { ...this.originLibrary };
        }
      } else {
        // 如果没有数据，也清空selectLibrary数据
        this.selectLibrary = { ...this.originLibrary };
      }
    },
    libraryChange2() {
      if (this.allLibrary && this.allLibrary.length > 0) {
        if (this.selectLibraryId2 > -1) {
          let url = API_URL["programInfo"];
          let params = {
            mac: this.mac,
            mode: this.mode,
            id: this.selectLibraryId2
          };

          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.selectLibrary2 = { ...res.data.data };
                //this.$Message.success(res.data.msg);
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        } else {
          // 如果没有选中任何项，清空selectLibrary数据
          this.selectLibrary2 = { ...this.originLibrary };
        }
      } else {
        // 如果没有数据，也清空selectLibrary数据
        this.selectLibrary2 = { ...this.originLibrary };
      }
    },
    downloadProgram() {
      let url = API_URL["programDownload"] + '?mac=' + this.mac + '&mode=' + this.mode + '&id=' + this.selectLibraryId;
      let params = new FormData();
      this.selectLibrary && Object.keys(this.selectLibrary).forEach(key => {
        params.append(key, this.selectLibrary[key]);
      });

      axios.post(url,
        params
      )
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    syncProgram() {
      this.syncModalVisible = true;
    },
    saveProgram() {
      let url = API_URL["programDownload"] + '?mac=' + this.mac + '&mode=' + this.mode + '&id=' + this.selectLibraryId2;
      let params = new FormData();
      this.selectLibrary2 && Object.keys(this.selectLibrary2).forEach(key => {
        params.append(key, this.selectLibrary2[key]);
      });
      axios.post(url,
        params
      )
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    exportProgram() {
      this.exportModalVisible = true;
    },
    importProgram() {
      this.importConfirmVisible = true;
    },
    handleImportConfirm() {
      // 确认导入，触发文件选择
      this.$refs.fileUpload.$el.querySelector('input[type="file"]').click();
      this.importConfirmVisible = false;
    },
    handleImportCancel() {
      this.importConfirmVisible = false;
    },

    handleBeforeUpload(file) {
      this.pageProgressModalVisible = true;
      this.oneProgress = null;
      const formData = new FormData();     
      formData.append('file', file);
     
      // 2. 使用axios发送，设置120秒超时
      axios.post(this.importUrl, formData, {
        timeout: 300000, // 120秒超时
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        // 参数顺序：response, file, fileList        
        this.successImport(res.data, file, []);
        this.pageProgressModalVisible = false;
      }).catch(error => {
        this.errorImport(error, file, []);
        this.pageProgressModalVisible = false;
      });

      return false
    },
    successImport(response) {
      if (response && response.code == 200) {
        this.$Message.success(response.msg);
        if (this.mode == 0) {
          this.libraryChange();
        } else {
          this.libraryChange2();
        }
      } else if (response && response.msg) {
        this.$Modal.info({
          title: this.getTranslation("m062"),
          content: response.msg.replace(/\n/g, '<br>'),
          okText: this.getTranslation("m063"),
        });
      }
    },
    errorImport() {
      this.$Message.error(this.getTranslation('c001'));
    },
    closeErr() {

    },
    changePowerControl(val) {
      this.$nextTick(() => {
        switch (val) {
          case 0:
            this.selectLibrary.OptWeld1 = 0
            this.selectLibrary.OptWeld2 = 0
            this.selectLibrary.OptWeld3 = 0
            break;
          case 1:
            this.selectLibrary.OptWeld1 = 1
            this.selectLibrary.OptWeld2 = 1
            this.selectLibrary.OptWeld3 = 1
            break
          default:
            break;
        }
      })
    },
    changePowerControl2(val) {
      this.$nextTick(() => {
        switch (val) {
          case 0:
            this.selectLibrary2.OptWeld1 = 0
            this.selectLibrary2.OptWeld2 = 0
            this.selectLibrary2.OptWeld3 = 0
            break;
          case 1:
            this.selectLibrary2.OptWeld1 = 1
            this.selectLibrary2.OptWeld2 = 1
            this.selectLibrary2.OptWeld3 = 1
            break
          default:
            break;
        }
      })
    },
    progressTypeHandler(msgData){
      if (msgData.type && msgData.type == 'importTask') {
          this.progressKey +=1;
          this.$set (this, 'oneProgress', msgData);
        }
    },
    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'progressType':
            this.progressTypeHandler(obj.data);
            break;
          default:
            break;
        }
      }
    }

  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
.other-line .input {
  width: 80%;
}

.other-line .row-line {
  margin: 4px 0;
}

.other-img {
  width: 17px;
}
</style>